import { render, staticRenderFns } from "./_base-content.vue?vue&type=template&id=3d5035d3&scoped=true"
import script from "./_base-content.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-content.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-content.vue?vue&type=style&index=0&id=3d5035d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5035d3",
  null
  
)

export default component.exports